import React, { useContext, useEffect, useState } from "react";
import { makeRequest } from "../../api";
import TadobaContext from "../Context/TadobaContext";

import { uploadZipFiles } from "../../utils/uploadUtils";
import { FaRegFolderOpen } from "react-icons/fa";
import { MdOutlineError } from "react-icons/md";
import { IoCheckmarkCircleSharp } from "react-icons/io5";

const PhaseFourUploadRoute = () => {
  const api = useContext(TadobaContext);

  useEffect(() => {
    if (!api.phaseFourLoading) {
      fetchZipUploadUrls();
    }
  }, []);

  const handleBack = () => {
    api.setPhaseFourZipFiles([]);
    api.setPhaseFourUploadResults([]);
    api.setPhaseFourUploadUrls([]);
  };

  const fetchZipUploadUrls = async () => {
    if (
      !api.phaseFourZipFiles ||
      api.phaseFourZipFiles.length === 0 ||
      api.phaseFourUploadResults.length > 0
    )
      return;

    api.setPhaseFourLoading(true);
    api.setPhaseFourSuccessMessage("");

    try {
      const result = await makeRequest(
        "post",
        "/api/v1/classification/phase_four_signed_urls/",
        { zipCount: api.phaseFourZipFiles.length }
      );

      api.setPhaseFourUploadUrls(result.data.data);
    } catch (error) {
      console.error("Error fetching URLs:", error);
      api.setPhaseFourLoading(false);
    }
  };

  useEffect(() => {
    if (
      api.phaseFourUploadResults.length > 0 ||
      api.phaseFourUploadUrls.length !== api.phaseFourZipFiles.length || 
      api.phaseFourZipFiles.length === 0 ||
      api.phaseFourUploadState
    ) return;

      handleUpload();
    
  }, [api.phaseFourUploadUrls, api.phaseFourUploadResults]);

  const handleUpload = async () => {
    api.setPhaseFourUploadState(true)

    const results = await uploadZipFiles(
      api.phaseFourZipFiles,
      api.phaseFourUploadUrls
    );
    api.setPhaseFourUploadResults(results);
    api.setPhaseFourUploadState(false)

    // Check if any file has a failed status
    const hasFailure = results.some((result) => result.status !== "Uploaded");

    api.setPhaseFourSuccessMessage(
      hasFailure
        ? "Upload failed for some files."
        : "All files have been successfully uploaded!"
    );
    api.setPhaseFourLoading(false);
  };

  return (
    <div className="Login">
      <div className="phase-four-container">
        <div className="phase-four-header">
          <span>Phase Four Upload</span>
        </div>

        <div className="phase-four-content">
          {api.phaseFourLoading && (
            <div className="spinner-container">
              <div className="spinner"></div>
              <h2>Uploading Files</h2>
              <p>Please wait, this may take a moment.</p>
            </div>
          )}

          {!api.phaseFourLoading && api.phaseFourSuccessMessage && (
            <h2
              className={`message ${
                api.phaseFourSuccessMessage.includes("failed")
                  ? "error"
                  : "success"
              }`}
            >
              {api.phaseFourSuccessMessage}
            </h2>
          )}

          <div className="upload-results">
            {api.phaseFourUploadResults.map((result, index) => (
              <div key={index} className="file-status">
                <div className="file-info">
                  <FaRegFolderOpen className="file-icon" />
                  <span>{result.name}</span>
                </div>
                <span>-</span>
                <div className="status-info">
                  {result.status === "Uploaded" ? (
                    <IoCheckmarkCircleSharp className="success-icon" />
                  ) : (
                    <MdOutlineError className="error-icon" />
                  )}
                  <span
                    className={`status-text ${
                      result.status === "Uploaded" ? "success" : "error"
                    }`}
                  >
                    {result.status}
                  </span>
                </div>
              </div>
            ))}
          </div>

          <div>
            <button className="phase-4-back-button" onClick={handleBack}>
              Back to Upload
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PhaseFourUploadRoute;
